import React, { FC, useCallback } from 'react';
import MarketReportPoster, { MarketReportPosterProps } from '@/common/components/MarketReportPoster/MarketReportPoster';
import { ModalName, useToggleModalsContext } from '@/common/contexts/globalModalContext';
import { ResponsiveImageUrls } from '@/types';
import Button from '@/common/components/Button/Button';
import styles from './SidebarCard.module.scss';

export interface SidebarProps extends MarketReportPosterProps {
  downloadButton: {
    text: string;
  };
}

interface SidebarComponentProps extends SidebarProps {
  imageUrls?: ResponsiveImageUrls;
}

const SidebarCard: FC<SidebarComponentProps> = ({
  title,
  quarter,
  marketReportLabel,
  imageUrls,
  downloadButton,
}) => {
  const toggleModal = useToggleModalsContext();

  const showModal = useCallback((): void => {
    toggleModal({ [ModalName.marketReport]: true });
  }, [toggleModal]);

  return (
    <div className={styles.sidebarContainer} id="sidebar-card">
      <MarketReportPoster
        customClassNames={{
          container: styles.poster,
          title: styles.posterTitle,
          quarter: styles.posterQuarter,
          label: styles.posterLabel,
        }}
        imageUrls={imageUrls}
        marketReportLabel={marketReportLabel}
        quarter={quarter}
        title={title}
      />
      <div className={styles.sidebarButtonWrapper}>
        <Button
          customClassNames={{ button: styles.sidebarButton }}
          onClick={showModal}
          text={downloadButton.text}
        />
      </div>
    </div>
  );
};

export default SidebarCard;
